import InlineCard from '../primitives/InlineCard';
import InlineCardEmpty from '../primitives/InlineCardEmpty';
import { buildCardModel } from '../lib/buildCardModel';
import { buildBreadcrumb } from '../lib/breadcrumbFormat';
import type { VisualProps, VisualWidget } from '../types';

const DEPTH_LABEL: Record<string, string> = {
    cat1: 'Industry',
    cat2: 'Category',
    cat3: 'Category',
    cat4: 'Category',
    cat5: 'Subcategory',
    leaf: 'Subcategory',
};

//`category_inline_card` — self overview of a category.
const CategoryInlineCard = ({ output, Frame, showEmptyState }: VisualProps) => {
    const typeLabel = DEPTH_LABEL[output?._entity?.depth ?? ''] ?? 'Category';
    const model = buildCardModel(output, typeLabel);
    if (!model) {
        return showEmptyState ? (
            <InlineCardEmpty
                breadcrumb={buildBreadcrumb(output, typeLabel)}
                typeLabel={typeLabel}
                Frame={Frame}
            />
        ) : null;
    }
    return <InlineCard {...model} Frame={Frame} />;
};

const widget: VisualWidget = {
    match: (input) =>
        input?.entity_type === 'category' &&
        input?.entity_relationship === 'self',
    Component: CategoryInlineCard,
};

export default widget;
